<template>
  <div class="full-height">
    <ld-header>
      休息室
    </ld-header>
    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="{use:false}"
      >
        <div class="box">
          <van-cell :border="false">
            <van-swipe
              class="round-md"
              :autoplay="3000"
              height="160"
            >
              <van-swipe-item
                v-for="(image, index_) in images"
                :key="index_"
              >
                <img v-lazy="image">
              </van-swipe-item>
            </van-swipe>
          </van-cell>
          <div class="box">
            <van-cell
              :border="false"
              center
            >
              <van-row>
                <van-col span="18">
                  {{ detail.terminal }}航站楼  {{ detail.securityCheck==1?'安检后':'安检前' }} <span v-show="detail.nearBoarding"> 邻近{{ detail.nearBoarding }}登机口</span>
                </van-col>
                <van-col
                  span="6"
                  class="font12 text-right"
                >
                  <!-- 营业中 -->
                </van-col>
              </van-row>
              <div>
                <span class="font16 font-bold">{{ detail.loungeNameCn }}</span>
                <!-- 豪华型
                <img
                  style="height:18px;"
                  src="~Assets/images/ht/hotel_type_03.png"
                > -->
              </div>
              <!-- <div>
                <van-rate
                  v-model="value"
                  allow-half
                  readonly
                  :size="14"
                  color="#ffd21e"
                  void-icon="star"
                  void-color="#eee"
                />
                <strong class="num main-color">&nbsp; 5</strong>分
              </div> -->
              <div>
                {{ detail.businessHoursStar }} - {{ detail.businessHoursEnd }}
              </div>
            </van-cell>
            <van-cell icon="location-o">
              <div class="font12">
                <div>
                  {{ detail.international==1?'国内出发':'国际出发' }} <span v-show="detail.terminal">{{ detail.terminal }}航站楼，</span>
                  <span v-show="searchInfo.nearBoarding "> 临近{{ searchInfo.nearBoarding }}登机口</span>，{{ detail.loungeAddress }} 
                </div>
                <div class="gray">
                  {{ searchInfo.cityName }}  {{ params.serverAirportName }}
                </div>
              </div>
            </van-cell>
          </div>
        
          <!--  -->
          <div class="box">
            <van-cell>设施</van-cell>
            <van-grid
              class="bg-white"
              :column-num="3"
              :border="false"
              icon-size="30"
            >
              <van-grid-item
                v-for="tab in detail.apFaceilitiesBeanList"
                :key="tab.id"
                :icon="tab.image"
                :text="tab.facilityName"
              />
            </van-grid>
          </div>
          <!--  -->
          <van-cell>服务须知</van-cell>
          <van-field
            type="textarea"
            autosize
            readonly
            v-model="detail.serverExplain"
          />
          <!-- <van-cell>
            <div>标准服务时间：2.0小时</div>
            <div>2周岁以下儿童可免费入内</div>
            <div>【温馨提示】</div>
            <div>1、适用航空公司：东航、上航、中联航、九元.</div>
            <div>2、如您携伴使用休息室服务,需与持卡人同一航班.</div>
            <div>3、不同机场休息室的登机提醒服务以实际提供的服务为准,请您到达贵宾厅后,请务必咨询现场工作人员确认,以免误机.</div>
            <div>(具体操作以该休息室相关规定为准)</div>
          </van-cell> -->
        </div>
      </mescroll-vue>
    </div>
    
    <!--  -->
    <ld-tabbar
      ref="tabbar"
      class="bg-white shadow"
    >
      <van-row
        class="full-width"
        type="flex"
        align="center"
        gutter="8"
        justify="center"
      >
        <van-col
          span="22"
        >
          <ld-button
            main
            size="md"
            @click="book"
          >
            购买服务
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Popup, ActionSheet, Cell, CellGroup, RadioGroup, Radio, Skeleton ,Rate , Grid, GridItem,Field} from 'vant'
// import { formatDate } from 'Utils/dateUtil'
import { mapGetters } from 'vuex'
import ldTabbar from 'Components/ldTabbar/ldTabbar'

export default {
  name: 'HtDetails',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Rate.name]:Rate,
    [Grid.name]:Grid,
    [GridItem.name]:GridItem,
    [Field.name]:Field,
    ldTabbar,
    [Skeleton.name]: Skeleton,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldButton: () => import('Common/ldButton'),
  },
  data() {
    return {
      images: [
        // 'http://image.dragonpass.com.cn/uploadFile/images/lounge/Base/N01701/_20190725155220_1.jpg',
        // 'http://image.dragonpass.com.cn/uploadFile/images/lounge/Base/N00031/N00031_D1(1).jpg',
        // 'http://image.dragonpass.com.cn/uploadFile/images/lounge/Base/N00030/N00030_20160217110421_S2.jpg',
      ],
      violation: '',
      violationItems: [],
      otherReasonDesc: '',
      priceList: [],
      isLoading: false,
      loading: false,
      path: '',
      clzcStr: '',
      value:2.5,
      detail:{},
      serviceData:[]
    }
  },
  computed: {
    ...mapGetters({
      searchInfo: 'restRoom/searchInfo',
      params: 'restRoom/params',
    }),
  },
  created () {
    this.$api['airService/restRoomDetail']({
      id:this.params.id
    }).then(res=>{
      let cache=res.data||{}
      this.detail=cache
      if(cache.faceImg){
        this.images=cache.faceImg.split('#')
      }
    })
    // this.$api['restRoom/queryFacilities']({
    // 	'type': 1,
    // }).then(res=>{
    // 	let cache=res.data||{}
    // 	this.serviceData=cache.queryFacilitiesList||[]
    // })
  },
  methods: {
    book() {
      this.$store.commit('restRoom/searchInfo',{images:this.images, ...this.detail})
      this.$router.push({path:'/restRoom/edit'})
    },
  },
  watch: {},
}

</script>
<style lang="less" scoped >
.box{
    padding-bottom: 5px;
}
.wrapper {
    height: calc(100vh - 96px);
    overflow: hidden;
}
.van-swipe img {
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: 160px;
    pointer-events: none;
}
</style>